import { API_URL } from '../../../app-config/constants';
import type AdminLink from '../../../types/AdminLink';
import { get } from '../request';

const BASE = `${API_URL}/admin-links`;

getSettingsLinks.operation = 'READ';
export function getSettingsLinks(adminNavRefresh?: boolean) {
    return get<AdminLink[]>(`${BASE}/settings`, {
        getData: {
            'nav-refresh': !!adminNavRefresh,
        },
    });
}

getPromotionsLinks.operation = 'READ';
export function getPromotionsLinks() {
    return get<AdminLink[]>(`${BASE}/links`);
}

getIntegrationsLinks.operation = 'READ';
export function getIntegrationsLinks() {
    return get<AdminLink[]>(`${BASE}/integrations`);
}

getAutomaticUserImportLinks.operation = 'READ';
export function getAutomaticUserImportLinks() {
    return get<AdminLink[]>(`${BASE}/automatic-user-import`);
}
